const MAX_DOMAIN_LENGTH = 253;

const ALLOWED_PROTOCOLS = ['http', 'https'];

const PROTOCOL_REGEX = /^([a-zA-Z][a-zA-Z0-9+\-.]*):\/\//;

const SUB_DOMAIN_REGEX = /^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/; // Max length for subdomain is 63 characters

const TOP_LEVEL_DOMAIN_REGEX = /^[a-zA-Z]{2,}$/;

const isProtocolValid = (protocol: string): boolean => {
  const match = protocol.match(PROTOCOL_REGEX);
  // No protocol found, so it is valid since it is optional
  if (!match) return true; 

  // Check if the protocol is in the allowed list
  // match[0] -> "https://"
  // match[1] -> "https"
  const protocolName = match[1].toLowerCase();
  if (ALLOWED_PROTOCOLS.includes(protocolName)) return true;

  return false;
}

export const isDomainValid = (url: string): boolean => {
  let domainName = url.trim();

  if (!isProtocolValid(domainName)) return false;
  // Remove protocol if it exists
  domainName = domainName.replace(PROTOCOL_REGEX, '');
  // Find the first occurrence of "/" and extract the domain part
  const slashIndex = domainName.indexOf('/');
  domainName = slashIndex !== -1 
    ? domainName.substring(0, slashIndex) 
    : domainName;
  // Check for query string and remove it if no explicit path exists
  // This is to handle cases like "example.com?query=string" 
  const queryIndex = domainName.indexOf('?');
  domainName = queryIndex !== -1 
    ? domainName.substring(0, queryIndex) 
    : domainName;

  if (domainName.length > MAX_DOMAIN_LENGTH) return false;

  const subDomains = domainName.split('.');

  if (subDomains.length < 2) return false;

  // Loop through all subdomains except the last one (top-level domain)
  for (let i = 0; i < subDomains.length - 1; i++) {
    if (!SUB_DOMAIN_REGEX.test(subDomains[i])) {
      return false;
    }
  }

  if (!TOP_LEVEL_DOMAIN_REGEX.test(subDomains[subDomains.length - 1])) return false;

  return true;
}